// DATA FROM VARIANT REFERENCE
const customvariantid = targetVariant.id;
const barcode = targetVariant.barcode;
const limit = targetVariant.quantity;
const targetSku = targetVariant.sku;
let productPricing = targetVariant.price / 100;

// PRICE FORMATTER
const formatter = new Intl.NumberFormat("ja-JP", {
  style: "currency",
  currency: "JPY",
});

let errorFontElement = document.createElement("p");
errorFontElement.textContent = "ERROR FONT";
errorFontElement.setAttribute("class", "cpb-category-font");

//GLOBAL VALUES
let cpbAddButton,
  cpbResetButton,
  cpbTitle,
  cpbQuantityValue,
  cpbIncreaseQuantityButton,
  cpbConditions = false,
  cpbQuantityOK = true,
  cpbFontSelector,
  productDescription = document.getElementById("productDescription"),
  cpbStep1Title,
  cpbStep1Description,
  cpbStep1Caution = document.getElementById("cpbStep1Caution"),
  cpbStep1CautionTarget,
  cpbStep1CautionTargetPosition,
  cpbAreas;

const url = new URL(window.location);
let line_key = url.searchParams.get("key");
let line_quantity = Number(url.searchParams.get("quantity"));

//BLAZZA対応文字数WATCHER
const isBlazza = ["RA0040-K", "RA0040-KS","RA0030-K","RA0030-KS"].includes(targetSku);
function updateMojisu(input, buttons) {
  if (!input || !buttons.length) return;

  const len = input.value.length;

  if (len <= 6) {
    if (!buttons[0].classList.contains("cpb-active")) {
      
    buttons[0].click();
}

  } else if (len <= 9) {
    if (!buttons[1].classList.contains("cpb-active")) {
    buttons[1].click();
}
  } else {
    if (!buttons[2].classList.contains("cpb-active")) {
    buttons[2].click();
}
  }
}
// VALIDATION CONSTANTS
// 許可される記号のリスト（拡張可能）
// 注意: 空白（スペース、タブ、改行）は許可されていません
const ALLOWED_SYMBOLS = [
  "\uFF0B", // ＋
  "\uFF0D", // －
  "\uFF0F", // ／
  "\uFF1D", // ＝
  "\uFF3F", // ＿
  "\uFF5E", // ～
  "\u25CB", // ○
  "\u25CE", // ◎
  "\u00D7", // ×
  "\u25CF", // ●
  "\u25B2", // ▲
  "\u25A0", // ■
  "\u25C6", // ◆
  "\u2605", // ★
  "\u2192", // →
  "\u2190", // ←
  "\uFF06", // ＆
  "\uFF01", // ！
  "\uFF1F", // ？
  "\u300C", // 「
  "\u300D", // 」
  "\uFF08", // （
  "\uFF09", // ）
  "\uFF0C", // ，
  "\uFF0C", // ，
  "\uFF02", // ”（全角）
  "\u0022", // "
  "\uFF07", // ’（全角）
  "\uFF0E", // ．
  "\u002E", // .（半角ドット）
  "\u30FB", // ・
  "\uFF03", // ＃
];

// 正規表現パターン（パフォーマンス最適化のため）
// 英数字、日本語（ひらがな、カタカナ、漢字）、許可された記号、文字列の間のスペース（半角・全角）を許可
// 注意: 先頭・最後尾のスペースは別途チェックでエラーにする
const VALID_CHAR_PATTERN =
  /^[A-Za-z0-9\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF\uFF0B\uFF0D\uFF0F\uFF1D\uFF3F\uFF5E\u25CB\u25CE\u00D7\u25CF\u25B2\u25A0\u25C6\u2605\u2192\u2190\uFF06\uFF01\uFF1F\u300C\u300D\uFF08\uFF09\uFF0C\u0022\u0027\u201C\u201D\u2018\u2019\uFF02\uFF07\uFF0E\.\u30FB\uFF03 \u3000]+$/;

// START ******************* CPB FUNCTIONS

/**
 * 入力値に許可されていない文字が含まれているかチェック
 * @param {string} inputValue - チェック対象の入力値
 * @returns {boolean} - すべての文字が許可されている場合 true、不正な文字がある場合 false
 */
function validateInputCharacters(inputValue) {
  // 入力値が空の場合は true を返す（空欄チェックは別関数で処理）
  if (!inputValue || inputValue.length === 0) {
    return true;
  }
// ★追加：半角記号を全角へ変換
  inputValue = inputValue
    .replace(/\+/g, "\uFF0B") // ＋
    .replace(/-/g, "\uFF0D") // －
    .replace(/\//g, "\uFF0F") // ／
    .replace(/=/g, "\uFF1D") // ＝
    .replace(/_/g, "\uFF3F") // ＿
    .replace(/~/g, "\uFF5E") // ～
    .replace(/&/g, "\uFF06") // ＆
    .replace(/!/g, "\uFF01") // ！
    .replace(/\?/g, "\uFF1F") // ？
    .replace(/\(/g, "\uFF08") // （
    .replace(/\)/g, "\uFF09") // ）
    .replace(/,/g, "\uFF0C") // ，
    .replace(/#/g, "\uFF03"); // ＃
 
  // 先頭・最後尾に空白（半角スペース、全角スペース、タブ、改行など）がある場合はエラー
  // trim()はチェックのためだけに使用し、入力値は変更しない
  if (inputValue !== inputValue.trim()) {
    return false;
  }

  // 正規表現を使用して一括チェック
  // 文字列の間のスペース（半角・全角）は許可される
  return VALID_CHAR_PATTERN.test(inputValue);
}
// Blazzaは英字（大文字のみ）・数字、記号は 「. 」「・」「-」 のみ対応
function validateBlazzaCharacters(inputValue) {
  if (!inputValue || inputValue.length === 0) {
    return true;
  }

  // 先頭・最後尾の空白は禁止
  if (inputValue !== inputValue.trim()) {
    return false;
  }

  // 大文字英字・数字・「.」「・」「-」のみ 文字列の間のスペース（半角・全角）は許可される
  return /^[A-Z0-9.\-・\u0020\u3000]+$/.test(inputValue);
}

// CPB APP REACTOR
function triggerReactChangeEvent(element, value) {
  let node;
  if (element instanceof window.HTMLElement) node = element;

  let inputTypes = [
    window.HTMLInputElement,
    window.HTMLSelectElement,
    window.HTMLTextAreaElement,
  ];

  let index = inputTypes.indexOf(node.__proto__.constructor);

  if (index > -1) {
    let eventType = index == 1 ? "change" : "input";
    let setValue = Object.getOwnPropertyDescriptor(node.__proto__, "value").set;
    let event = new Event(eventType, { bubbles: true });

    setValue.call(node, value);
    node.dispatchEvent(event);
  }
}

function checkTextInput() {
  let textInput = document.querySelectorAll(
    ".cpb-option-type-input__wrapper input"
  );
  let errorCounter = 0;
 
  cpbAreas.forEach((area) => {
    let description = area.querySelector(".cpb-category-desc");
    let textLimit = area.querySelector("input");
    let element = description.querySelector(".cpb__area__description");

    if (!element && textLimit) {
      let moreDescription = document.createElement("p");
      moreDescription.setAttribute("class", "cpb__area__description");
      
     if (!isBlazza) {
      moreDescription.textContent = `※1行に${
      textLimit.maxLength - 4
      }文字まで入力いただけます。`;
      description.appendChild(moreDescription);
      }
    }
  });

  if (textInput)
    textInput.forEach((input) => {
  if (isBlazza) {
  if (input.closest(".cpb__area__input_left")) {
    const optionCount = input
      .closest(".cpb__area__input_left")
      .querySelectorAll(".option-type-input").length;

    if (optionCount === 1) {
      updateMojisu(
        input,
        document.querySelectorAll(".mojisu_left .cpb-option-type-text")
      );
    }
  }

  if (input.closest(".cpb__area__input_right")) {
    const optionCount = input
      .closest(".cpb__area__input_right")
      .querySelectorAll(".option-type-input").length;

    if (optionCount === 1) {
      updateMojisu(
        input,
        document.querySelectorAll(".mojisu_right .cpb-option-type-text")
      );
    }
  }
}
      let inputLimit = input.maxLength - 4;
      let parent = input.parentElement;

      let errorLimit = parent.querySelector(".cpb__area__error__invalid");
      let errorEmpty = parent.querySelector(".cpb__area__error__empty");
      let errorInvalidChar = parent.querySelector(".cpb__area__error__invalid_char");

      if (!errorLimit) {
        const invalidTxt = document.createElement("p");
        invalidTxt.setAttribute("class", "cpb__area__error__invalid");
        invalidTxt.textContent = `印字できるのは${inputLimit}文字までです。`;
        parent.appendChild(invalidTxt);
        errorLimit = invalidTxt;
      }

      if (!errorEmpty) {
        const emptyTxt = document.createElement("p");
        emptyTxt.setAttribute("class", "cpb__area__error__empty");
        emptyTxt.textContent = `空欄のままオーダーできません。このエリアに印字が不要な場合は、行の選択を解除してから空欄にしてください。`;

        errorEmpty = emptyTxt;
        parent.appendChild(emptyTxt);
      }

      if (!errorInvalidChar) {
        const invalidCharTxt = document.createElement("p");
        invalidCharTxt.setAttribute("class", "cpb__area__error__invalid_char");
        invalidCharTxt.textContent = isBlazza
        ? "使用できる文字は大文字英字・数字・指定記号のみです。"
        : "使用できない文字が含まれています。英数字、日本語、および指定記号記号のみ入力できます。";
        parent.appendChild(invalidCharTxt);
        errorInvalidChar = invalidCharTxt;
      }

      // エラー状態をリセット
      let hasError = false;
      const isValidCharacter = isBlazza? validateBlazzaCharacters(input.value): validateInputCharacters(input.value);
      // 1. 空欄チェック（既存の機能を維持）
      if (input.value.length == 0) {
        input.classList.add("input--error");
        errorEmpty.style.display = "block";
        errorLimit.style.display = "none";
        errorInvalidChar.style.display = "none";
        errorCounter++;
        hasError = true;
      }
      // 2. 文字数チェック（既存の機能を維持）
      else if (input.value.length > inputLimit) {
        input.classList.add("input--error");
        errorLimit.style.display = "block";
        errorEmpty.style.display = "none";
        errorInvalidChar.style.display = "none";
        errorCounter++;
        hasError = true;
      }
      // 3. 文字種チェック（新規追加）
     
      else if (!isValidCharacter) {
        input.classList.add("input--error");
        errorInvalidChar.style.display = "block";
        errorLimit.style.display = "none";
        errorEmpty.style.display = "none";
        errorCounter++;
        hasError = true;
      }

      // エラーがない場合
      if (!hasError) {
        input.classList.remove("input--error");
        errorLimit.style.display = "none";
        errorEmpty.style.display = "none";
        errorInvalidChar.style.display = "none";
      }
    });

  const textLine = document.querySelectorAll(
    ".cpb__area__line .option-type-text.active"
  );

  if (!textLine.length) errorCounter++;

  if (errorCounter > 0) return false;
  else return true;
}

function checkQuantityValue() {
  if (cpbQuantityValue.value >= limit) {
    cpbIncreaseQuantityButton.setAttribute("disabled", true);
  } else cpbIncreaseQuantityButton.removeAttribute("disabled");

  if (cpbQuantityValue.value > limit) cpbQuantityOK = false;
  else cpbQuantityOK = true;

  return cpbQuantityOK;
}

function checkFontExist(event) {
  // const font = isBlazza
  //   ? (
  //       document.querySelector(".fontFamily .cpb-has-value") ||
  //       document.querySelector(".fontFamily [class*='singleValue']")
  //     )
  //   : (
  //       document.querySelector(".fontFamily .cpb-has-value") ||
  //       document.querySelector(".fontFamily [class*='singleValue']")?.textContent?.trim() === "楷書"
  //     );
  const font =
  document.querySelector(".fontFamily .cpb-has-value") ||
  document.querySelector(".fontFamily [class*='singleValue']");

  const fontDescription = document.querySelector(".font__missing");

  if (fontDescription) {
    if (font) fontDescription.style.display = "none";
    else fontDescription.style.display = "block";
  }

  return !!font;
}

function isZenkaku(input) {
  for (let i = 0; i < input.length; i++) {
    let code = input.charCodeAt(i);
    if (
      !(code >= 0x3040 && code <= 0x309f) &&
      !(code >= 0x30a0 && code <= 0x30ff)
    ) {
      return false;
    }
  }
  return true;
}

// END ******************* CPB FUNCTIONS

// START ******************* CPB MOUNTED
let customProductPrice = product.price / 100;
let customComparePrice = product.compare_at_price / 100;

// INITIATE MODAL
function activateModal() {
  const howtoButton = document.querySelector(
    "[data-modal='how-to-custom-product']"
  );
  const howToModal = document.getElementById(`how-to-custom-product`);

  howtoButton.addEventListener("click", function () {
    howToModal.classList.toggle("modal-container__active");
    howToModal.classList.toggle("modal-container__zindex");
  });
}
//BLAZZA対応関数
function getCurrentProductPricing() {
  const text =
    document.querySelector(
      ".cpb-product-price [data-testid='multycurrency-price']"
    )?.textContent || "";

  const cpbprice = Number(text.replace(/[^0-9.-]+/g, ""));

  return cpbprice;
}

function clearCustomPricing() {
  document.querySelectorAll(".custom-name-pricing").forEach(el => el.remove());
  document.querySelectorAll(".custom-pricing-container").forEach(el => el.remove());
  document.querySelectorAll(".custom-name-pricing-total").forEach(el => el.remove());
  document.querySelectorAll(".compare-pricing").forEach(el => el.remove());
}
// INITIATE CUSTOM PRICING
function initCustomPricing() {
  let priceContainer = document.querySelector(".cpb-product-full-price");

  if (customComparePrice) {
    //ELEMENTS
    let customNamePricing = document.createElement("span");
    customNamePricing.setAttribute(
      "class",
      "custom-name-pricing compare-price-exist"
    );

    if (customProductPrice > 0) {
      let customSaleIcon = document.createElement("span");
      customSaleIcon.setAttribute("class", "compare-sale-icon");
      customSaleIcon.textContent = "今だけ半額！";
      customNamePricing.append(customSaleIcon);
    }

    priceContainer.append(customNamePricing);

    let comparePricingDiv = document.createElement("div");
    comparePricingDiv.setAttribute("class", "compare-pricing");
    comparePricingDiv.innerHTML += `<u id='comparePricing'>¥${customComparePrice}</u> 名入れオーダー価格`;

    priceContainer.append(comparePricingDiv);

    let customPricingContainer = document.createElement("div");
    customPricingContainer.setAttribute("class", "custom-pricing-container");

    let customPricingSpan = document.createElement("span");
    customPricingSpan.setAttribute("id", "custom-pricing");
    customPricingSpan.textContent = "+" + formatter.format(productPricing);

    customPricingContainer.append(customPricingSpan);
    customPricingContainer.innerHTML += "<p>商品価格</p>";

    priceContainer.append(customPricingContainer);

    let customNamePricingTotal = document.createElement("div");
    customNamePricingTotal.setAttribute("class", "custom-name-pricing-total");
    customNamePricingTotal.innerHTML +=
      "<div class='custom-name-pricing-total'>TOTAL<span id='custom-price-total'>" +
      formatter.format(productPricing + customProductPrice) +
      "</span></div>";

    priceContainer.append(customNamePricingTotal);
  } else {
    let customNamePricing = document.createElement("span");
    customNamePricing.setAttribute("class", "custom-name-pricing");
    customNamePricing.textContent = "名入れオーダー価格";
    priceContainer.append(customNamePricing);

    let customPricingContainer = document.createElement("div");
    customPricingContainer.setAttribute("class", "custom-pricing-container");
    customPricingContainer.innerHTML += `<span id='custom-pricing'>+ ${formatter.format(
      productPricing
    )}</span><p>商品価格</p>`;
    priceContainer.append(customPricingContainer);

    let customNamePricingTotal = document.createElement("div");
    customNamePricingTotal.setAttribute("class", "custom-name-pricing-total");
    customNamePricingTotal.innerHTML += `<div class='custom-name-pricing-total'>TOTAL<span id='custom-price-total'>${formatter.format(
      productPricing + customProductPrice
    )}</span></div>`;
    priceContainer.append(customNamePricingTotal);
  }
}

document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", function (event) {
  // UPDATE VARIABLES
  cpbAddButton = document.querySelector(".cpb-add-to-cart-button");
  cpbResetButton = document.querySelector(".cpb-reset-button > span");
  textInputArea = document.querySelectorAll(".cpb-name-line input");
  cpbQuantityValue = document.querySelector(".cpb-quantity-value");
  cpbIncreaseQuantityButton = document.querySelector(
    ".cpb-quantity-button-increase"
  );
  cpbFontSelector = document.querySelector(".cpb-option-type-select input");
  cpbAreas = document.querySelectorAll(".cpb__area__input");
  cpbTitle = document.querySelector(".cpb-panels-container");
  cpbStep1Title = document.querySelector(".cpb-panel-title");
  cpbStep1Description = document.querySelector(".cpb-panel-description");

  // SET MAX LIMIT
  cpbQuantityValue.setAttribute("max", limit);

  // REPLACE TEXT
  cpbResetButton.textContent = "オーダー内容をリセット";
  cpbAddButton.textContent = "この内容でオーダーする";

 if (!document.querySelector('script[type="speculationrules"]')) {
    const speculationScript = document.createElement('script');
    speculationScript.type = 'speculationrules';
    speculationScript.textContent = JSON.stringify({
      prerender: [{ urls: ['/cart'] }]
    });
    document.head.appendChild(speculationScript);
  }

  // INITIATE CART SETTINGS
  if (line_key) {
    const quantityLabel = document.querySelector(".cpb-quantity-label");
    const quantityAction = document.querySelector(".cpb-quantity-actions");

    if (quantityLabel && quantityAction) {
      quantityLabel.style.display = "none";
      quantityAction.style.display = "none";
    }
  }

  // ENTER PRODUCT DESCRIPTION
  cpbTitle.prepend(productDescription.content);

  cpbStep1CautionTargetPosition = cpbStep1Description
    ? "beforeend"
    : "afterend";
  cpbStep1CautionTarget = cpbStep1Description
    ? cpbStep1Description
    : cpbStep1Title;
  cpbStep1CautionTarget.insertAdjacentHTML(
    cpbStep1CautionTargetPosition,
    cpbStep1Caution.innerHTML
  );

  activateModal();

 if (isBlazza) {
  initCustomPricingBlazza();
} else {
  initCustomPricing();
}

  // QUANTITY INPUT CHANGE blazza条件対応
const observer = new MutationObserver(function (mutations) {
  mutations.forEach((mutation) => {
    let targetQuantity = mutation.target.value;

    if (isBlazza) {
      if (targetQuantity <= limit) {
        setTimeout(() => {
          clearCustomPricing();
           initCustomPricingBlazza();
        }, 700);
      }
    } else {
      if (targetQuantity <= limit) {
        let total = targetQuantity * productPricing;

        document.getElementById("custom-pricing").textContent =
          "+" + formatter.format(total);

        document.getElementById("custom-price-total").textContent =
          formatter.format(customProductPrice * targetQuantity + total);

        if (customComparePrice) {
          document.getElementById("comparePricing").textContent =
            formatter.format(customComparePrice * targetQuantity);
        }
      }
    }
  });

  if (cpbQuantityValue.value >= limit)
    cpbIncreaseQuantityButton.setAttribute("disabled", true);
  else
    cpbIncreaseQuantityButton.removeAttribute("disabled");
});

observer.observe(cpbQuantityValue, {
  attributes: true,
  childList: true,
  characterData: true,
  subtree: true,
});
document.body.addEventListener("click", function (e) {
  const option = e.target.closest(".cpb-option-type-text");

  if (!isBlazza || !option) return;

  setTimeout(() => {
    clearCustomPricing();
     initCustomPricingBlazza();
  }, 700);
});
function initCustomPricingBlazza() {
  let priceContainer = document.querySelector(".cpb-product-full-price");
const quantity = Number(cpbQuantityValue?.value || 1);
const cpbPrice = getCurrentProductPricing();

const customTotal = productPricing * quantity;
const finalTotal = cpbPrice + customTotal;
  if (customComparePrice) {
    //ELEMENTS
    let customNamePricing = document.createElement("span");
    customNamePricing.setAttribute(
      "class",
      "custom-name-pricing compare-price-exist"
    );
    console.log(customProductPrice)
    if (customProductPrice > 0) {
      let customSaleIcon = document.createElement("span");
      customSaleIcon.setAttribute("class", "compare-sale-icon");
      customSaleIcon.textContent = "今だけ半額！";
      customNamePricing.append(customSaleIcon);
    }

    priceContainer.append(customNamePricing);

    let comparePricingDiv = document.createElement("div");
    comparePricingDiv.setAttribute("class", "compare-pricing");
    comparePricingDiv.innerHTML += `<u id='comparePricing'>¥${customComparePrice}</u> 名入れオーダー価格`;

    priceContainer.append(comparePricingDiv);

    let customPricingContainer = document.createElement("div");
    customPricingContainer.setAttribute("class", "custom-pricing-container");

    let customPricingSpan = document.createElement("span");
    customPricingSpan.setAttribute("id", "custom-pricing");
    customPricingSpan.textContent = "+" + formatter.format(customTotal);

    customPricingContainer.append(customPricingSpan);
    customPricingContainer.innerHTML += "<p>商品価格</p>";

    priceContainer.append(customPricingContainer);

    let customNamePricingTotal = document.createElement("div");
    customNamePricingTotal.setAttribute("class", "custom-name-pricing-total");
    customNamePricingTotal.innerHTML +=
      "<div class='custom-name-pricing-total'>TOTAL<span id='custom-price-total'>" +
      formatter.format(finalTotal)
      "</span></div>";

    priceContainer.append(customNamePricingTotal);
  } else {
    let customNamePricing = document.createElement("span");
    customNamePricing.setAttribute("class", "custom-name-pricing");
    customNamePricing.textContent = "名入れオーダー価格";
    priceContainer.append(customNamePricing);

    let customPricingContainer = document.createElement("div");
    customPricingContainer.setAttribute("class", "custom-pricing-container");
    customPricingContainer.innerHTML += `<span id='custom-pricing'>+ ${formatter.format(
      productPricing*quantity
    )}</span><p>商品価格</p>`;
    priceContainer.append(customPricingContainer);

    let customNamePricingTotal = document.createElement("div");
    customNamePricingTotal.setAttribute("class", "custom-name-pricing-total");
    customNamePricingTotal.innerHTML += `<div class='custom-name-pricing-total'>TOTAL<span id='custom-price-total'>${formatter.format(
      finalTotal
    )}</span></div>`;
    priceContainer.append(customNamePricingTotal);
  }
}
  // STICKY MOBILE
  window.addEventListener("scroll", function () {
    if (window.scrollY > 1 && window.innerWidth <= 640) {
      document.querySelector(".cpb-preview-container").classList.add("mobile");
    } else {
      document
        .querySelector(".cpb-preview-container")
        .classList.remove("mobile");
    }
  });

  // UPDATE QUANTITY IF QUANTITY IS FOUND IN URL
  if (line_quantity) triggerReactChangeEvent(cpbQuantityValue, line_quantity);
});
// END ******************* CPB MOUNTED

// START ******************* CPB UPDATED

/**
 *
 * Disable the add button if
 * Check the text input field for error such as over the limit
 * Quantity is greater or no inventory at all
 * Font doesnt exist
 *
 */
document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", (event) => {
  if (!cpbAddButton) return;

  setTimeout(() => {
    console.log(
      checkTextInput() +
        " && " +
        checkQuantityValue() +
        " && " +
        checkFontExist()
    );
    if (checkTextInput() && checkQuantityValue() && checkFontExist())
      cpbAddButton.removeAttribute("disabled");
    else cpbAddButton.setAttribute("disabled", "");
  }, 10);
});

// END ********************* CPB UPDATED

// START ******************* CPB BEFORE ADD TO CART

/**
 * CLEAN CPB PRODUCT PROPERTIES
 *
 * Filters the and remove properties that are not needed and changing them
 *
 */
document.body.addEventListener("before-add-to-cart", ({ detail }) => {
  console.log('before-add-to-cart fired', Date.now())

  const target = document.querySelector('.cpb-panels-container')
  console.log('target:', target)

  if (!target) return
  const baseText = 'オーダー内容送信中'
  let dotCount = 0

  setInterval(() => {
    dotCount = (dotCount + 1) % 4
    cpbAddButton.textContent = baseText + '.'.repeat(dotCount)
  }, 400)
  if (getComputedStyle(target).position === 'static') {
    target.style.position = 'relative'
  }

  const overlay = document.createElement('div')
  overlay.style.position = 'absolute'
  overlay.style.inset = '0'
  overlay.style.zIndex = '99999'
  overlay.style.background = 'transparent'
  overlay.style.pointerEvents = 'auto'
  overlay.style.cursor = 'not-allowed'

  target.appendChild(overlay)

  console.log('overlay added')
  console.clear();
  const cpbProperties = detail;

  delete cpbProperties.properties.SKU;
  cpbProperties.properties._CustomTarget = targetSku;
console.table(cpbProperties.properties);
  for (const key of Object.keys(cpbProperties.properties)) {
    const value = cpbProperties.properties[key];
    console.log(value)
    if (key.includes("文字エリア") && key.includes("_")) {
      let area = key.slice(5, 6);
      let row = key.slice(11, 12);
      if (isBlazza && row >= 4) {
        row -= 3;
      }
      cpbProperties.properties[`文字エリア${area}「${row}行目」`] = value;
      delete cpbProperties.properties[key];
    }
  }
  console.table(cpbProperties.properties);
  // UPDATES PROPERTIES
  CPB.changeCartData(cpbProperties);
});

// END ******************* CPB BEFORE ADD TO CART

// START ******************* CPB ADD TO CART
function customOnlyAddToCartCheck(needAdjustQuantity) {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      let targetLine = cart.items.find((item) => item.key === line_key);

      if (!targetLine && line_key) {
        const variantId = Number(line_key.split(":")[0]);

        targetLine = cart.items.find((item) =>
          item.id === variantId &&
          (!item.properties || item.properties._custom !== "custom")
        );

        if (targetLine) {
          console.log("line_keyが変わったので差し替え:", targetLine.key);
          line_key = targetLine.key;
        }
      }

      if (needAdjustQuantity && line_quantity > 1) {
        line_quantity--;
      }

      if (
        targetLine &&
        (!targetLine.properties || targetLine.properties._custom !== "custom")
      ) {
        return customOnlyAddToCart();
      }

      return addCustomRegular();
    })
    .catch((error) => {
      console.error("ERROR:", error);
    });
}
// Only triggered when product is added from the cart page
function customOnlyAddToCart() {
  fetch("/cart/change", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: line_key,
      quantity: line_quantity,
      properties: {
        _custom: "custom",
        _barcode: barcode,
      },
    }),
  })
    .then((response) => {
      console.log("regular product changed, the present quantity is"+line_key+":"+line_quantity);
      console.log("Change regular product");
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error("ERROR:", error);
    });

}
// Add product to Cart
function addCustomRegular() {
  fetch("/cart/add", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: customvariantid,
      quantity: cpbQuantityValue.value,
      properties: {
        _custom: "custom",
        _barcode: barcode,
      },
    }),
  })
    .then((response) => {
      console.log("custom regular product added");
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error("ERROR:", error);
    });
}
// Add product to Cart with Campaign present
function addCustomCampaign() {
  // 本番のステッカー
  const presentVariantId = 51434421682494;

  // BPのステッカー
  // const presentVariantId = 45293991493783;

  fetch("/cart/add", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: customvariantid,
      quantity: cpbQuantityValue.value,
      properties: {
        _custom: "custom",
        _barcode: barcode,
      },
    }),
  })
    .then((response) => {
      console.log("custom regular product added");
      return fetch("/cart/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: presentVariantId,
          quantity: 1,
        }),
      });
    })
    .then((response) => {
      console.log("custom campaign product added");
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error("ERROR:", error);
    });
}

// Add product to Cart with Pentagon Deluxe bundle
function addCustomPentagonDeluxe() {
  // const pentagonDeluxeVariantId = 41708201246871; // 開発ストア
  const pentagonDeluxeVariantId = 41509381734594; // 本番ストア
const pentagonBlackVariantId = 41509899206850; //2026.5.11hpgbk対応
  fetch("/cart/add", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: customvariantid,
      quantity: cpbQuantityValue.value,
      properties: {
        _custom: "custom",
        _barcode: barcode,
      },
    }),
  })
    .then(() => fetch("/cart.js"))
    .then((response) => response.json())
    .then((cart) => {
      const alreadyInCart = cart.items.some(
        (item) => item.variant_id == pentagonBlackVariantId
      );
      if (alreadyInCart) return Promise.resolve();
      return fetch("/cart/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: pentagonBlackVariantId,
          quantity: 1,
        }),
      });
    })
    .then(() => {
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error("ERROR:", error);
    });
}
function addCustomHandPumpBlue() {
  const handPumpBlueVariantId = 41515626299586;

  fetch("/cart/add", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: customvariantid,
      quantity: cpbQuantityValue.value,
      properties: {
        _custom: "custom",
        _barcode: barcode,
      },
    }),
  })
    .then(() => fetch("/cart.js"))
    .then((response) => response.json())
    .then((cart) => {
      const alreadyInCart = cart.items.some(
        (item) => item.variant_id == handPumpBlueVariantId
      );

      if (alreadyInCart) return Promise.resolve();

      return fetch("/cart/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: handPumpBlueVariantId,
          quantity: 1,
        }),
      });
    })
    .then(() => {
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error("ERROR:", error);
    });
}
document.addEventListener("cpb-add-to-cart", () => {
  console.log("cpb-add-to-cart fired");
  const bg4800SkuList = ["B7G4800", "B6G4800","F4N5000","F5N5000","F4K5000","F5K5001","F5K5000","F5K5001-WB"];
  const isBG4800 = bg4800SkuList.includes(targetSku);
  const handPumpProcuctList = [
    "ADF520",
    "ADF420MOL",
    "ADF420B",
    "ADF420Y",
    "ADF520F",
    "ADF420F",
    "ADF540W",
    "ADF541W",
    "ADF550DFL",
    "ADF551DFL",
    "ADF561NL",
  ];

  const isHandPump = handPumpProcuctList.includes(targetSku);
  const targetSkuList = [
    "F5K5000",
    "F5K5001",
    "F5K5001-WB",
    "F5K4000",
    "F5K4000-WB",
    "F5K4000-WR",
    "F5K4000-WG",
    "F5K4000-O",
    "F5K3000",
    "F5K3000-WB",
    "F5K3000-WR",
    "F4K5000",
    "F4K4000",
    "F4K4000-WB",
    "F4K4000-WR",
    "F4K4000-WG",
    "F4K4000-O",
    "F4K3000",
    "F4K3000-WB",
    "F4K3000-WR",
    "F9K4000",
    "F9K3000-BR",
    "F9K3000-RK",
    "F3K9200-YB",
    "F3K9200-YR",
    "F3K9200-YO",
    "F5K9100",
    "F5K9200",
    "F5K9300",
  ];
  const isPelada = targetSkuList.includes(targetVariant.sku);
  if (line_key) {
   const needAdjustQuantity = isBG4800 || isHandPump;
customOnlyAddToCartCheck(needAdjustQuantity);
  }
  else if (isBG4800) addCustomPentagonDeluxe();
  else if (isHandPump) addCustomHandPumpBlue();
  else if (isPelada) addCustomCampaign();
  else addCustomRegular();
});

// END ******************* CPB ADD TO CART

// START ******************* BFCACHE FIX
// iPhone Chrome でブラウザバック後に bfcache からページが復元された場合、
// CPB React アプリの内部 state が古いままになりプロパティが更新されない問題への対策。
// pageshow イベントで復元を検知し、強制リロードする。
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});
// END ******************* BFCACHE FIX

// START *******************26.5.20match the quantity between pages
document.addEventListener("DOMContentLoaded", () => {
  const quantityParams = new URLSearchParams(window.location.search);

  const quantityFromMenu = quantityParams.get("quantity");

  if (!quantityFromMenu) return;

  const quantityInput = document.querySelector(
    ".cpb-quantity-value"
  );

  if (quantityInput) {
    quantityInput.value = quantityFromMenu;

    quantityInput.dispatchEvent(
      new Event("input", { bubbles: true })
    );

    quantityInput.dispatchEvent(
      new Event("change", { bubbles: true })
    );
  }
});
// END *******************26.5.20match the quantity between pages

// START ******************* CPB TESTING SCRIPTS * ADDITIONAL SCRIPTS * Fix from other CPB bugs

/**
 * Check all input are valid
 * Checks whether the input is valid and within the maxlength
 * @returns boolean
 */
/*
function checkTextInput(){
    let isValid = true
    let areaInvalid = 0
    let areaEmpty = 0

    cpbAreas.forEach(area => {
        const textAreas = area.querySelectorAll('.cpb-option-type-input__wrapper input')
        const errorEmpty = area.querySelector('.cpb__area__error__empty')
        const errorInvalid = area.querySelector('.cpb__area__error__invalid')

        let textEmpty = false;
        let textInvalid = false;

        textAreas.forEach(input=> {    
            if(input.value.length <= 0 ) {
                textEmpty = true;
            }
            if(input.value.length > (input.maxLength - 4)) {
                textInvalid = true
            }
        })

        if(textInvalid) {
            areaInvalid++
            errorInvalid.style.display = 'block'
        }
        else 
            errorInvalid.style.display = 'none'

        if(textEmpty) 
            errorEmpty.style.display = 'block'
        else {
            areaEmpty++
            errorEmpty.style.display = 'none'
        }
    })

    if(areaEmpty == 0)
        isValid = false
    if(areaInvalid > 0) 
        isValid = false


	if(isValid) {
		const errorEmpty = document.querySelectorAll('.cpb__area__error__empty')
		if(errorEmpty)
		errorEmpty.forEach(error => error.style.display = 'none')
	}

    return isValid;  
}
*/
// CHECK IF TEXT ARE EMPTY
/*
	if(checkTextInput() && checkIfInputLimitIsOk() &&  cpbQuantityValue.value <= limit )
		cpbAddButton.removeAttribute('disabled')
	else
		cpbAddButton.setAttribute('disabled','')
	*/

// STCIKY FIX
/*
	window.addEventListener("scroll", function() {
		if (window.pageYOffset > 1 && window.innerWidth <= 640) {
		  document.querySelector('.cpb-preview-container').classList.add('mobile');
		} else {
		  document.querySelector('.cpb-preview-container').classList.remove('mobile');
		}
	});


    	// APPEND FONT ERROR
	let cpbFontContainer = document.querySelector('.cpb-category-fontFamily')
	cpbFontContainer.append(errorFontElement)
	*/

/*
document.addEventListener('cpb-add-to-cart', function(event) {
	
	let addQuantity = cpbQuantityValue.value

	// SET CUSTOM REGULAR DATA
	let addData = { 
		'id': customvariantid ,
		'quantity': addQuantity,
		'properties':{
			'_custom': 'custom',
			'_barcode': barcode,
		}
	}

	addProductToCart(addData)

	setTimeout(()=> {
		console.log('adding')
	},500 )

})
*/

/*
	// STCIKY FIX
	$(window).on("scroll", function() {
		if ($(window).scrollTop() > 1 && $(window).width() <= 640) {
			$('.cpb-preview-container').addClass('mobile')
		} else {
			$('.cpb-preview-container').removeClass('mobile')
		}
	});
*/

// ｷﾞガAB文
/*
function hankana2Zenkana(str) {
    var kanaMap = {
        'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
        'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
        'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
        'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
        'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
        'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
        'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
        'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
        'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
        'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
        'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
        'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
        'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
        'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
        'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
        'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
        'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
        'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
        '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
    };
    var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
    return str
            .replace(reg, function (match) {
                return kanaMap[match];
            })
            .replace(/ﾞ/g, '゛')
            .replace(/ﾟ/g, '゜');
};
function zenkaku2Hankaku(str) {
    return str.replace(/[A-Za-z0-9]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
    });
}
function letterZenkaku(category) {
	let input = category.querySelector('input')
	let text = input.value
	text = zenkaku2Hankaku(text)
	text = hankana2Zenkana(text)
	triggerReactChangeEvent(input, text)
}
*/
/*
	if(textInputArea)
	textInputArea.forEach(input => {
		let errorTextElement = document.createElement('p')
		errorTextElement.setAttribute('class','cpb-category-error')
		errorTextElement.textContent = `印字できるのは${input.maxLength - 4}文字までです。`

		input.parentElement.parentElement.append(errorTextElement)

		errorTextElement = document.createElement('p')
		errorTextElement.setAttribute('class','cpb-category-hankaku')
		input.parentElement.parentElement.append(errorTextElement)
	})
	*/
// END ******************* CPB TESTING
